import SPID from 'spid-smart-button/dist/spid-button.min.js'

$(window).on("turbolinks:load",function(){
  if($('#spid-button').length > 0)
  { $.get( "idps", function(data) {})
      .done(function(idps_list) {
        SPID.init({
          lang: 'it',
          selector: '#spid-button', // opzionale
          method: 'POST', // opzionale
          url: 'spid_entrypoint',
          fieldName: 'idp', // opzionale
          supported: idps_list.supported,
          /*mapping: {
            'https://identity.sieltecloud.it': 'http://192.168.0.110:8088'
          },*/
          extraProviders : idps_list.extraProviders,
        }); 
        $('#spid-button').find('.spid-button').removeAttr('hidden');
      })
      .fail(function() {
        //alert( "error" );
      })
  }
});